/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveLPTokensDetailsFetchersRepository,
  CurveLPTokensDetailsFetchersRepositoryInterface,
} from "../CurveLPTokensDetailsFetchersRepository";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "FetcherAlreadyAdded",
    type: "error",
  },
  {
    inputs: [],
    name: "FetcherIsNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetcher",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "fetcher",
        type: "address",
      },
    ],
    name: "FetcherAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "fetcher",
        type: "address",
      },
    ],
    name: "FetcherRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "_fetcher",
        type: "address",
      },
    ],
    name: "addFetcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensFetchersRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getFetchers",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getLPTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "_fetcher",
        type: "address",
      },
    ],
    name: "removeFetcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveLPTokensDetailsFetchersRepositoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveLPTokensDetailsFetchersRepositoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveLPTokensDetailsFetchersRepository__factory extends ContractFactory {
  constructor(
    ...args: CurveLPTokensDetailsFetchersRepositoryConstructorParams
  ) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveLPTokensDetailsFetchersRepository";
  }

  deploy(
    _repository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveLPTokensDetailsFetchersRepository> {
    return super.deploy(
      _repository,
      overrides || {}
    ) as Promise<CurveLPTokensDetailsFetchersRepository>;
  }
  getDeployTransaction(
    _repository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_repository, overrides || {});
  }
  attach(address: string): CurveLPTokensDetailsFetchersRepository {
    return super.attach(address) as CurveLPTokensDetailsFetchersRepository;
  }
  connect(signer: Signer): CurveLPTokensDetailsFetchersRepository__factory {
    return super.connect(
      signer
    ) as CurveLPTokensDetailsFetchersRepository__factory;
  }
  static readonly contractName: "CurveLPTokensDetailsFetchersRepository";
  public readonly contractName: "CurveLPTokensDetailsFetchersRepository";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensDetailsFetchersRepositoryInterface {
    return new utils.Interface(
      _abi
    ) as CurveLPTokensDetailsFetchersRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensDetailsFetchersRepository {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensDetailsFetchersRepository;
  }
}
